"use client"

import React from 'react'
import { TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useFormNavigationItems } from "@/hooks/use-form-navigation-items"
import { CircleEllipsis } from "lucide-react"

export interface FormTabsProps {
  completedSections: Record<string, boolean>
  hiddenSections: Record<string, boolean>
}

export function FormTabs({
  completedSections,
  hiddenSections
}: FormTabsProps) {
  const items = useFormNavigationItems({ completedSections, hiddenSections })
  
  return (
    <TabsList>
      {items.map((item) => {
        return (
          <TabsTrigger key={item.id} value={item.id}>
            {item.label}
            {!item.completed && (
              <span title="Incomplete">
                <CircleEllipsis className="h-4 w-4 text-primary" />
                <span className="sr-only">Incomplete</span>
              </span>
            )}
          </TabsTrigger>
        )
      })}
    </TabsList>
  )
}

